(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_faq_section"] && !Shopify.designMode) return;
  try {
    

(function () {
  const accordion = document.getElementById('custom_faq_section__accordion');
  if (!accordion) return;

  const items = accordion.querySelectorAll('.custom_faq_section__item');

  items.forEach(function (item) {
    const btn = item.querySelector('.custom_faq_section__btn');
    const content = item.querySelector('.custom_faq_section__content');

    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('active');

      // Close all other open items
      items.forEach(function (otherItem) {
        if (otherItem !== item && otherItem.classList.contains('active')) {
          otherItem.classList.remove('active');
          otherItem.querySelector('.custom_faq_section__btn').setAttribute('aria-expanded', 'false');
          otherItem.querySelector('.custom_faq_section__content').style.maxHeight = null;
        }
      });

      // Toggle current item
      if (isOpen) {
        item.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        item.classList.add('active');
        btn.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
